/* unplugin-vue-components disabled */import script from "./RoleCapabilityCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleCapabilityCard.vue?vue&type=script&setup=true&lang=js"

import "./RoleCapabilityCard.vue?vue&type=style&index=0&id=6adf24a4&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6adf24a4"]])

export default __exports__